import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, LayoutGridIcon, PlusCircleIcon, StarIcon, InfoIcon, SparklesIcon } from 'lucide-react';
export const Sidebar = () => {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;
  const navItems = [{
    path: '/',
    icon: HomeIcon,
    label: 'Home'
  }, {
    path: '/apps',
    icon: LayoutGridIcon,
    label: 'All Apps'
  }, {
    path: '/create',
    icon: PlusCircleIcon,
    label: 'Create App'
  }, {
    path: '/featured',
    icon: StarIcon,
    label: 'Featured'
  }];
  return <aside className="w-64 bg-white border-r border-gray-200 flex-shrink-0 hidden md:flex flex-col" data-id="element-229">
      <nav className="flex-1 p-4 space-y-1" data-id="element-230">
        {navItems.map(item => <Link key={item.path} to={item.path} className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${isActive(item.path) ? 'bg-indigo-50 text-indigo-600' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-231">
            <item.icon className="h-5 w-5" data-id="element-232" />
            <span className="font-medium" data-id="element-233">{item.label}</span>
          </Link>)}
      </nav>

      {/* Bottom Section */}
      <div className="p-4 border-t border-gray-200 space-y-1" data-id="element-234">
        <Link to="/marketing" className="flex items-center space-x-3 px-4 py-3 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-235">
          <SparklesIcon className="h-5 w-5" data-id="element-236" />
          <span className="font-medium" data-id="element-237">About RealUseAI</span>
        </Link>
        <Link to="/about" className="flex items-center space-x-3 px-4 py-3 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-238">
          <InfoIcon className="h-5 w-5" data-id="element-239" />
          <span className="font-medium" data-id="element-240">About</span>
        </Link>
      </div>
    </aside>;
};